import * as React from 'react'
import ReactModal from 'react-modal'
import { Button } from 'antd-mobile'
import { getLangKey, getTextByKey } from '@feedback/utils/util'
import { getAppConfig } from '@feedback/utils/CONST'
import { isVestAppid } from '@feedback/utils/siteConfig'
import styles from './index.module.scss'
import clsx from 'clsx'

export interface IProps {
  title?: string
  message?: string
  open: boolean
  onCancel?: () => void
  cancelText?: string
  onConfirm?: () => void
  confirmText?: string
}

const LeaveWarningModal: React.FC<IProps> = ({
  open,
  title,
  message,
  onCancel,
  cancelText,
  onConfirm,
  confirmText
}) => {
  const { appid } = getAppConfig() || {}
  const langKey = getLangKey()
  const isRTL = langKey === 'ar-SA'
  const isVest = isVestAppid(appid)

  React.useEffect(() => {
    ReactModal.setAppElement('body')
  }, [])

  return (
    <ReactModal isOpen={open} closeTimeoutMS={250}>
      <section
        className={clsx(
          styles['leave-warning-modal'],
          isVest ? styles.vest : styles?.[appid]
        )}
        dir={isRTL ? 'rtl' : 'ltr'}
      >
        {/* 马甲站深色弹窗无标题（对齐原型 .contact-confirm-dialog）；非 vest 保留 */}
        {!isVest && <h2>{title || getTextByKey('Note') || 'Note'}</h2>}
        <p>{message || ''}</p>
        <section className={'button-wrapper'}>
          {onCancel && (
            <Button
              className='button is-light'
              onClick={() => (onCancel ? onCancel() : null)}
            >
              {cancelText || getTextByKey('cancel')}
            </Button>
          )}
          {onConfirm && (
            <Button
              className='button'
              onClick={() => (onConfirm ? onConfirm() : null)}
            >
              {confirmText || getTextByKey('confirm')}
            </Button>
          )}
        </section>
      </section>
    </ReactModal>
  )
}

export default LeaveWarningModal
